import { HttpClient } from './HttpClient.js';

export const UserManagementService = {

    getUserManagement: async function (type) {
        return await HttpClient.get(`/user/get-users-by-profile/${type}`).then(response => response);
    },
    
    registerUser: async function (formUser) {
        return await HttpClient.post(`/user`, formUser).then(response => response);
    },
    
    updateUserType: async function (formUserType, user) {
        return await HttpClient.post(`/user/put-update/${user}`, formUserType).then(response => response);
    },
    
    updatePassword: async function (formUserType, user) {
        return await HttpClient.post(`/user/put-update-password/${user}`, formUserType).then(response => response);
    },
    
    deleteUser: async function (user) {
        return await HttpClient.post(`/user/put-delete/${user}`, null).then(response => response);
    },
    
    activateUser: async function (user) {
        return await HttpClient.post(`/user/put-delete/${user}`, null).then(response => response);
    },
    
    getUsersByDispatch: async function (user = '') {
        return await HttpClient.get(user ? `/user/get-by-dispatch/${encodeURIComponent(user)}` : '/user/get-by-dispatch').then(response => response);
    },

    deleteUserReal: async function (user) {
        return await HttpClient.delete(`/user/delete-user/${user}`, null).then(response => response);
    },

    cargaMasiva: async function (file) {
        return await HttpClient.post(`/user/massive-users`, file).then(response => response);
    },
    reset2FA: async function (user) {
        return await HttpClient.put(`/user/reset-2fa/${user}`, null).then(response => response);
    }

}